import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { ArticleProductTypeList } from "@msuite/utils/types";
import { client } from "@/hono";
import { ArticleProductTypesMenu } from "./article-product-types-menu";
import { columns } from "./table-config";

export function ArticleProductTypes() {
	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["article-product-types"],
		queryFn: async () => {
			const response = await client.stock["article-product-types"].$get();
			const data = await responseHandler(response);
			return data.articleProductTypes as ArticleProductTypeList;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data}
				columns={columns as any}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				menu={<ArticleProductTypesMenu />}
				persistenceKey="data-stock-article-product-types-table"
			/>
		</ContentBox>
	);
}
